import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'GeoVastu Gyan Kosh',
    description: 'Every remedy, method, brahmastra, samagri, muhurta and Q&A from the Geo Vastu courses on Vastu, Interior Vastu, Swar Vigyan, Muhurta and Forecasting, tagged and searchable.',
    placeholder: 'Search remedies, samagri, events and questions.',
    url: getOrigin()
}
